import Button from '@rio-cloud/rio-uikit/components/button/Button';
import useDarkMode from '@rio-cloud/rio-uikit/hooks/useDarkMode';
import { useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {useDispatch, useSelector} from 'react-redux';
import { useNavigate } from 'react-router';

import {ButtonContainer, Container, Content, Image, StyledHeading} from "@/components/organism/HeroSection/HeroSection.styles";
import { getUserProfile } from '@/configuration/login/loginSlice';
import {gaPush, GET_STARTED_SECTION_ACTIONS, GET_STARTED_SECTION_CATEGORY} from "@/configuration/setup/googleAnalytics";
import { EAppRoutes } from '@/routes/routes';
import { setCurrentLayout } from '@/store/layout/layoutSlice';

const texts = {
  greeting: 'getStartedPage.heroSection.greeting',
  introduction: 'getStartedPage.heroSection.introduction',
  description: 'getStartedPage.heroSection.description',
  learnMoreLabel: 'getStartedPage.getStartedSection.learnMore.label',
  startChatLabel: 'getStartedPage.common.startChat.label',
};

type HeroSectionProps = {
  scrollFunction: () => void;
};

const HeroSection = ({ scrollFunction }: HeroSectionProps) => {
  const intl = useIntl();
  const user = useSelector(getUserProfile);
  const isDarkMode = useDarkMode();

  const dispatch = useDispatch();
  const pageTopRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const handleStartConversation = () => {
    gaPush({
      category: GET_STARTED_SECTION_CATEGORY,
      action: GET_STARTED_SECTION_ACTIONS.CLICK_START_CHAT,
      label: 'User clicked start chat',
    });
    dispatch(setCurrentLayout('chat'));
    navigate(EAppRoutes.CHAT);
  };

  useEffect(() => {
    if (pageTopRef.current) {
      pageTopRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <Container isDarkMode={isDarkMode}>
      <div ref={pageTopRef} style={{ position: 'absolute', top: '0' }} />
      <Content>
        <StyledHeading className="h2">
          {intl.formatMessage(
            { id: texts.greeting },
            { name: <span className="text-color-primary">{user?.name}!</span> },
          )}
        </StyledHeading>
        <p>
          <FormattedMessage id={texts.description} />
        </p>
        <ButtonContainer>
          <Button bsStyle={Button.PRIMARY} onClick={handleStartConversation}>
            <FormattedMessage id={texts.startChatLabel} />
          </Button>
          <Button bsStyle={Button.DEFAULT} onClick={scrollFunction}>
            <FormattedMessage id={texts.learnMoreLabel} />
          </Button>
        </ButtonContainer>
      </Content>
      <Image src="assets/images/hero-image.svg" alt="Hero" />
    </Container>
  );
};

export default HeroSection;
